import { useTranslation } from 'react-i18next';

interface SizeGuideProps {
  volume: string;
  productName: string;
}

export default function SizeGuide({ volume, productName }: SizeGuideProps) {
  const { t } = useTranslation();

  return (
    <div className="bg-white rounded-2xl p-6 md:p-8 border border-[#E8E8E6]">
      <h3 className="text-sm tracking-[0.12em] uppercase font-medium text-[#2A2A2A] mb-6">
        {t('products.sizeGuide')}
      </h3>

      <div className="flex flex-col md:flex-row items-center gap-8">
        {/* Product silhouette */}
        <div className="relative flex flex-col items-center">
          <div className="w-24 h-36 rounded-xl bg-[#F0EFED] border-2 border-[#E8E8E6] flex items-center justify-center">
            <span className="text-[10px] text-[#8A8A8A] font-light text-center px-2">
              {productName.split(' ').slice(0, 3).join(' ')}
            </span>
          </div>
          <span className="mt-2 text-xs font-medium text-[#7B1113]">{volume}</span>
        </div>

        {/* Hand comparison */}
        <div className="flex items-center gap-4">
          <div className="relative">
            <svg width="160" height="120" viewBox="0 0 160 120" fill="none" className="text-[#E8E8E6]">
              {/* Palm */}
              <ellipse cx="80" cy="70" rx="55" ry="40" fill="currentColor" />
              {/* Thumb */}
              <ellipse cx="30" cy="50" rx="18" ry="28" fill="currentColor" transform="rotate(-30 30 50)" />
              {/* Fingers */}
              <rect x="50" y="15" width="14" height="45" rx="7" fill="currentColor" />
              <rect x="68" y="10" width="14" height="50" rx="7" fill="currentColor" />
              <rect x="86" y="12" width="14" height="48" rx="7" fill="currentColor" />
              <rect x="104" y="20" width="14" height="42" rx="7" fill="currentColor" />
              {/* 50ml marker */}
              <circle cx="80" cy="70" r="22" stroke="#7B1113" strokeWidth="2" fill="none" strokeDasharray="4 2" />
            </svg>
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center">
              <span className="text-[10px] font-medium text-[#7B1113] bg-white/80 px-1.5 py-0.5 rounded">
                {volume}
              </span>
            </div>
          </div>
          <div className="flex flex-col gap-1">
            <span className="text-xs font-medium text-[#2A2A2A]">{t('products.realSize')}: {volume}</span>
            <span className="text-[11px] text-[#8A8A8A] font-light max-w-[200px]">
              {t('products.sizeGuideDesc')}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}